import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Package } from 'lucide-react';
import { AdminStocksSkeleton } from './components/AdminStocksSkeleton';
import { AdminStocksStats } from './components/AdminStocksStats';
import { AdminStocksTable } from './components/AdminStocksTable';
import { useAdminStocks } from './hooks/useAdminStocks';
import {
  getBrandOptions,
  getServiceDeskOptions,
  getStocksStats,
} from './utils';

const AdminStocks = () => {
  const { t } = useTranslation();
  const { stocks, loading, error } = useAdminStocks();
  const serviceDeskOptions = useMemo(() => getServiceDeskOptions(stocks), [stocks]);
  const brandOptions = useMemo(() => getBrandOptions(stocks), [stocks]);
  const stats = useMemo(() => getStocksStats(stocks), [stocks]);

  if (loading && stocks.length === 0) {
    return <AdminStocksSkeleton />;
  }

  if (error) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 p-4 text-red-700">
        <h3 className="font-bold">{t('An error occurred')}</h3>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto space-y-6 px-4 py-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="flex items-center gap-2 text-3xl font-bold text-gray-900">
            <Package className="h-8 w-8" />
            {t('Stocks')}
          </h1>
          <p className="mt-1 text-gray-500">
            {t('View the items with stock reported from the configured providers')}
          </p>
        </div>
      </div>

      <AdminStocksStats stats={stats} />
      <AdminStocksTable
        stocks={stocks}
        serviceDeskOptions={serviceDeskOptions}
        brandOptions={brandOptions}
      />
    </div>
  );
};

export default AdminStocks;
